import { useAppContext } from 'components/Context/AppContext';
import { PaginationTable, TableWrapper } from 'components/Global';
import { imageColorList } from 'components/HomeComponent/Content/DriverComponent/DriverReview';
import DriverReviewItem from 'components/HomeComponent/Content/DriverComponent/DriverReview/driver-review-item';
import { updateReviewVisibility } from 'features/reviews/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as StarIcon } from 'icons/star.svg';
import { getVehicleRating, getVehicleReviews } from 'features/vehicle/action';

const ReviewIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="14" fill="#F1A33A" />
    <path
      d="M7.00001 14C7.00001 10.134 10.134 7 14 7C17.866 7 21 10.134 21 14C21 17.866 17.866 21 14 21C12.816 21 11.699 20.7055 10.72 20.1855L7.95601 20.9715C7.82755 21.0079 7.69169 21.0094 7.56248 20.9757C7.43327 20.9421 7.31538 20.8746 7.22099 20.7801C7.1266 20.6857 7.05914 20.5678 7.02556 20.4385C6.99199 20.3093 6.99352 20.1734 7.03001 20.045L7.81601 17.2815C7.27878 16.2712 6.99853 15.1442 7.00001 14ZM11 12.5C11 12.6326 11.0527 12.7598 11.1465 12.8536C11.2402 12.9473 11.3674 13 11.5 13H16.5C16.6326 13 16.7598 12.9473 16.8536 12.8536C16.9473 12.7598 17 12.6326 17 12.5C17 12.3674 16.9473 12.2402 16.8536 12.1464C16.7598 12.0527 16.6326 12 16.5 12H11.5C11.3674 12 11.2402 12.0527 11.1465 12.1464C11.0527 12.2402 11 12.3674 11 12.5ZM11.5 15C11.3674 15 11.2402 15.0527 11.1465 15.1464C11.0527 15.2402 11 15.3674 11 15.5C11 15.6326 11.0527 15.7598 11.1465 15.8536C11.2402 15.9473 11.3674 16 11.5 16H14.5C14.6326 16 14.7598 15.9473 14.8536 15.8536C14.9473 15.7598 15 15.6326 15 15.5C15 15.3674 14.9473 15.2402 14.8536 15.1464C14.7598 15.0527 14.6326 15 14.5 15H11.5Z"
      fill="white"
    />
  </svg>
);

const ReviewVehicleCard = ({ data, reviewData, reviewLoading }) => {
  const dispatch = useDispatch();

  const { setShowConfirmation, showToast } = useAppContext();

  const [currentPage, setCurrentPage] = useState(1);

  const toggleVisibilityHandler = (review) => {
    const MESSAGE = review.shown
      ? 'Anda yakin akan menyembunyikan review ini?'
      : 'Anda yakin akan menampilkan review ini?';

    setShowConfirmation({
      message: MESSAGE,
      show: true,
      onClick: async () => {
        try {
          await dispatch(updateReviewVisibility({ id: review.id, data: { is_shown: !review.shown } })).unwrap();
          dispatch(getVehicleReviews({ id: data.id, page: currentPage, order_type_id: 1 }));
        } catch (error) {
          showToast({ type: 'error', message: `Gagal Mengubah visibilitas review - ${error?.message}` });
        }
      },
    });
  };

  const renderDailyRating = () => {
    return (
      <div className="review-summary-card__list">
        <div className="review-summary-card__item">
          <span className="review-summary-card__label">Dengan Supir</span>
          {data?.rating_vehicle_with_driver?.total_reviews > 0 ? (
            <div className="review-summary-card__score">
              <StarIcon color="#f1a33a" />
              <span className="review-summary-card__value">
                {data?.rating_vehicle_with_driver?.rating ?? '-'}
                /5
              </span>
            </div>
          ) : (
            <div className="review-summary-card__score">
              <StarIcon color="#C3C3C3" />
              <span className="review-summary-card__value">Belum ada rating</span>
            </div>
          )}
        </div>

        <div className="review-summary-card__item">
          <span className="review-summary-card__label">Tanpa Supir</span>
          {data?.rating_vehicle_without_driver?.total_reviews > 0 ? (
            <div className="review-summary-card__score">
              <StarIcon color="#f1a33a" />
              <span className="review-summary-card__value">
                {data?.rating_vehicle_without_driver?.rating ?? '-'}
                /5
              </span>
            </div>
          ) : (
            <div className="review-summary-card__score">
              <StarIcon color="#C3C3C3" />
              <span className="review-summary-card__value">Belum ada rating</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderReviewData = () => {
    if (reviewLoading) {
      return (
        <div className="review-summary-card__review-loading">
          <p>Loading...</p>
        </div>
      );
    } else if (reviewData?.data?.length > 0) {
      return (
        <div className="review-summary-card__review-list">
          {reviewData?.data?.map((item, index) => (
            <DriverReviewItem
              key={item.id}
              reviewData={item}
              bgColor={imageColorList[index % 10]}
              onToggleVisibility={toggleVisibilityHandler}
              type="vehicle"
            />
          ))}
          <PaginationTable
            currentPage={currentPage}
            onPageChange={(newPage) => setCurrentPage(newPage)}
            totalCount={reviewData?.pagination?.total}
          />
        </div>
      );
    } else {
      return (
        <div className="review-summary-card__review-empty">
          <p>Belum Ada Review</p>
        </div>
      );
    }
  };

  useEffect(() => {
    if (!data?.id) return;

    dispatch(getVehicleReviews({ id: data.id, page: currentPage, order_type_id: 1 }));
  }, [currentPage, data, dispatch]);

  useEffect(() => {
    if (!data?.id) return;

    dispatch(getVehicleRating(data.id));
  }, [data, dispatch]);

  return (
    <TableWrapper
      title="Review"
      icon={<ReviewIcon />}
      className="review-summary-card"
      CustomFilterComponent={renderDailyRating()}
    >
      {renderReviewData()}
    </TableWrapper>
  );
};

export default ReviewVehicleCard;
